export default __webpack_public_path__ + "static/media/AmericanMcGee.f2f06989.png";